import React, { Component } from 'react';
import ImageViewer from './ImageViewer';

class ItemImageList extends Component {
  renderImage(imageData) {
    return (
      <div key={imageData.id}>
        <ImageViewer data={imageData.content}/>
      </div>
    );
  }

  render() {
    return (
      
      <div className="gallery">
        <div className="images">
          {this.props.images.map(imageData => this.renderImage(imageData))}
        </div>
      </div>     
    )
  }
}

export default ItemImageList;